// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { listItemTextClasses } from '@mui/material/ListItemText';
import { menuItemClasses } from '@mui/material/MenuItem';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { menuColors } from './menuColors';
export var Menu = function(mode) {
    var c = menuColors(mode);
    var _obj;
    var override = {
        MuiMenuList: {
            styleOverrides: {
                root: {
                    padding: rem(8),
                    display: 'flex',
                    flexDirection: 'column',
                    gap: rem(4)
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    borderRadius: rem(8)
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: c.background,
                    borderRadius: rem(8),
                    boxShadow: '0px 10px 30px 0px rgba(0, 0, 0, 0.15)',
                    minWidth: rem(160)
                },
                list: {
                    padding: rem(8),
                    display: 'flex',
                    flexDirection: 'column',
                    gap: rem(4)
                }
            },
            defaultProps: {}
        },
        MuiMenuItem: {
            styleOverrides: {
                root: (_obj = {
                    display: 'flex',
                    alignItems: 'center',
                    color: c.text,
                    padding: "".concat(rem(8), " ").concat(rem(12)),
                    gap: rem(8),
                    borderRadius: rem(8),
                    minHeight: 'auto',
                    fontSize: rem(14),
                    fontWeight: 500,
                    fontStyle: 'normal',
                    lineHeight: rem(18)
                }, _define_property(_obj, "& .".concat(svgIconClasses.root), {
                    color: c.icon,
                    fontSize: rem(20)
                }), // MUI's own MenuItem docs recommend wrapping the icon in ListItemIcon.
                // List.tsx scopes its circular icon badge to a real ListItem ancestor, so
                // reset the leftover MUI default gutter here to keep the icon flush with
                // MenuItem's own gap-based layout.
                _define_property(_obj, "& .".concat(listItemIconClasses.root), {
                    minWidth: 'unset'
                }), _define_property(_obj, "& .".concat(listItemTextClasses.secondary), {
                    color: c.subtext
                }), _define_property(_obj, "&&:hover:not(.".concat(menuItemClasses.disabled, ")"), {
                    backgroundColor: c.hover.background
                }), _define_property(_obj, "&&.".concat(menuItemClasses.disabled), _define_property({
                    opacity: 1,
                    color: c.disabled.text
                }, "& .".concat(svgIconClasses.root), {
                    color: c.disabled.icon
                })), _define_property(_obj, "&&.".concat(menuItemClasses.selected), _define_property({
                    backgroundColor: c.active.background,
                    color: c.active.text
                }, "& .".concat(svgIconClasses.root), {
                    color: c.active.icon
                })), _define_property(_obj, "&&.".concat(menuItemClasses.selected, ":hover"), {
                    backgroundColor: c.activeHover.background
                }), _obj),
                dense: _define_property({
                    padding: rem(4),
                    gap: rem(4),
                    fontSize: rem(12),
                    lineHeight: rem(16)
                }, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(16)
                })
            },
            variants: [
                {
                    props: {
                        size: 'condensed'
                    },
                    style: _define_property({
                        padding: rem(4),
                        gap: rem(4),
                        fontSize: rem(12),
                        lineHeight: rem(16)
                    }, "& .".concat(svgIconClasses.root), {
                        fontSize: rem(16)
                    })
                },
                {
                    props: {
                        size: 'large'
                    },
                    style: _define_property({
                        padding: "".concat(rem(16), " ").concat(rem(24)),
                        gap: rem(16),
                        minHeight: rem(80),
                        fontSize: rem(24),
                        fontWeight: 600,
                        lineHeight: rem(28)
                    }, "& .".concat(svgIconClasses.root), {
                        fontSize: rem(24)
                    })
                }
            ],
            defaultProps: {}
        }
    };
    return override;
};

//# sourceMappingURL=Menu.js.map